import axios, { AxiosInstance, AxiosResponse } from 'axios';
import { GlsPartner } from '../../models/gls-partner.model';
import ColisportApiResource from './colisport-api-resource.model';
import { FilterGlsPartners } from '../../models/filter-glsPartners.model';

export default class GlsPartnerApi implements ColisportApiResource {
  readonly apiUrlPath = 'glsPartner';

  constructor(readonly httpClient: AxiosInstance) {}

  async createGlsPartner(partnerEmail: string): Promise<AxiosResponse<GlsPartner>> {
    return axios.post(`${this.apiUrlPath}/create/${partnerEmail}`);
  }

  async getPartnersWithFilters(query?: string): Promise<AxiosResponse<FilterGlsPartners>> {
    return this.httpClient.get(`${this.apiUrlPath}/filters${query !== '' ? `?${query}` : ''}`, {
      params: `filters?${query}`,
    });
  }

  async updatePartner(
    update: Partial<GlsPartner> & { email: string },
  ): Promise<AxiosResponse<GlsPartner>> {
    return this.httpClient.patch(`${this.apiUrlPath}/update`, update);
  }
}
